import { render, staticRenderFns } from "./dashboard-message.vue?vue&type=template&id=e293b676"
import script from "./dashboard-message.vue?vue&type=script&lang=js"
export * from "./dashboard-message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports